export default "__VITE_ASSET__Ir4s1nHJ__"